module.exports = __webpack_public_path__ + "img/slide2-screen.8930d9e6.png";